// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"aae0173b","208":"752f1b98","293":"705886d6","453":"0630e2a9","516":"0422cd48","917":"ed68eeeb","946":"7a92655f"}[chunkId] + ".chunk.js";
};